import partnerConsents from '@/api/partnerConsents'
import helpers from '@/utils/helpers'

const state = {
  partners: [],
  loading: false,
  error: null,
}

const mutations = {
  SET_PARTNERS(state, partners) {
    state.partners = partners
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  UPSERT_PARTNER(state, partner) {
    const index = state.partners.findIndex(
      (item) => item.partner_name === partner.partner_name,
    )
    if (~index) {
      state.partners[index] = { ...state.partners[index], ...partner }
    } else {
      state.partners = [].concat(partner, state.partners)
    }
  },
}

const actions = {
  async fetchPartners({ commit }) {
    commit('SET_LOADING', true)
    return await partnerConsents
      .fetchAll()
      .then((response) => {
        commit('SET_PARTNERS', response.data.data?.partners || [])
        commit('SET_LOADING', false)
        return response.data.data?.partners || []
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        commit('SET_LOADING', false)
      })
  },

  async updateConsents({ commit }, { partnerName, payload }) {
    return await partnerConsents
      .update(partnerName, payload)
      .then((response) => {
        const data = response.data.data || {}
        commit('UPSERT_PARTNER', {
          partner_name: data.partner_name || partnerName,
          consents: data.consents || [],
          consents_count: (data.consents || []).length,
          configured: true,
          updated_at: data.updated_at || null,
        })
        return response.data
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        return error.response?.data || { status: false }
      })
  },

  async syncConsents({ commit }) {
    return await partnerConsents
      .sync()
      .then((response) => response.data)
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        return error.response?.data || { status: false }
      })
  },

  async exportConsents({ commit }, partnerName) {
    return await partnerConsents
      .exportConsents(partnerName)
      .then((response) => response.data)
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        return error.response?.data || { status: false }
      })
  },

  async importConsents({ commit }, { partnerName, payload }) {
    return await partnerConsents
      .importConsents(partnerName, payload)
      .then((response) => {
        const data = response.data.data || {}
        commit('UPSERT_PARTNER', {
          partner_name: data.partner_name || partnerName,
          consents: data.consents || [],
          consents_count: (data.consents || []).length,
          configured: true,
          updated_at: data.updated_at || null,
        })
        return response.data
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        return error.response?.data || { status: false }
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
